import http from '@/utils'
import api from '@/api/apiUrls'

export const serviceUtils = {
  fetchFeatureFlags
}

function fetchFeatureFlags(_sn) {
  return http.get(api.FEATURE_FLAG.replace('{serial}', _sn))
}
